/****************************************************
 * Module Name:  MineProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class MineProxy {
    static GetAllMines = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/mine",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetSingleMine = (mineId, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/mine/${mineId}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static CheckMineNameAvailable = (mine, callback) => {
        let params = {
            mine: mine,
        };

        restAPICall(
            Constants.MANAGER_URL + "/mine/available",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddMine = (mine, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/mine",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(mine),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateMine = (mine, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/mine",
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(mine),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

};